import { useState, useMemo } from 'react'
import {
  blogPosts,
  getCategories,
  getTags,
  searchPosts,
  filterByCategories,
  filterByTags
} from '../data/blogPosts'
import BlogCard from '../components/blog/BlogCard'
import BlogSearch from '../components/blog/BlogSearch'
import BlogFilters from '../components/blog/BlogFilters'
import ScrollReveal from '../components/shared/ScrollReveal'
import GradientText from '../components/shared/GradientText'
import { useBlogUpvotes } from '../hooks/useBlogUpvotes'
import './Blog.css'

export default function Blog() {
  const [searchQuery, setSearchQuery] = useState('')
  const [selectedCategories, setSelectedCategories] = useState([])
  const [selectedTags, setSelectedTags] = useState([])
  const { handleUpvote, hasUpvoted, getUpvoteCount } = useBlogUpvotes()

  const categories = getCategories()
  const tags = getTags()

  // Filter logic
  const filteredPosts = useMemo(() => {
    let result = blogPosts

    // Search filter
    result = searchPosts(result, searchQuery)

    // Category filter
    result = filterByCategories(result, selectedCategories)

    // Tag filter
    result = filterByTags(result, selectedTags)

    return result
  }, [searchQuery, selectedCategories, selectedTags])

  return (
    <div className="draft-page">
      {/* Hero Section */}
      <section className="draft-hero">
        <div className="container">
          <ScrollReveal>
            <span className="draft-badge">Blog & Insights</span>
          </ScrollReveal>
          <ScrollReveal delay={0.1}>
            <h1 className="draft-title">
              Solar Industry <GradientText gradient="solar">Insights</GradientText>
            </h1>
          </ScrollReveal>
          <ScrollReveal delay={0.2}>
            <p className="draft-subtitle">
              Expert perspectives on solar monitoring, predictive maintenance, and operations.
            </p>
          </ScrollReveal>
        </div>
      </section>

      {/* Search and Filters */}
      {(blogPosts.length > 0 || searchQuery || selectedCategories.length > 0 || selectedTags.length > 0) && (
        <section className="blog-filters-section">
          <div className="container">
            <BlogSearch query={searchQuery} onChange={setSearchQuery} />
            <BlogFilters
              categories={categories}
              tags={tags}
              selectedCategories={selectedCategories}
              selectedTags={selectedTags}
              onCategoryChange={setSelectedCategories}
              onTagChange={setSelectedTags}
            />
          </div>
        </section>
      )}

      {/* Blog Grid */}
      <section className="blog-grid-section">
        <div className="container">
          {filteredPosts.length > 0 ? (
            <div className="blog-grid">
              {filteredPosts.map((post, i) => (
                <ScrollReveal key={post.id} delay={i * 0.1}>
                  <BlogCard
                    post={post}
                    upvoteCount={getUpvoteCount(post.id, post.upvotes)}
                    hasUpvoted={hasUpvoted(post.id)}
                    onUpvote={() => handleUpvote(post.id)}
                  />
                </ScrollReveal>
              ))}
            </div>
          ) : (
            <div className="blog-empty">
              {blogPosts.length === 0 ? (
                <>
                  <p>No blog posts yet.</p>
                  <p style={{ fontSize: '0.9375rem' }}>Check back soon for updates!</p>
                </>
              ) : (
                <p>No posts found matching your criteria.</p>
              )}
            </div>
          )}
        </div>
      </section>
    </div>
  )
}
